<style scoped>
</style>

<script>
  import Equipment from "./equipment.ts";
  export default Equipment;
</script>